module.exports = __webpack_public_path__ + "99cf20a7c7da32d3ebd63b28a80daccd.png";